var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InterviewSection'),_c('MediaSection'),_c('AffiliateSection'),_c('CatchphraseSection',{attrs:{"sectionId":"intro-D"},on:{"go-register":function($event){return _vm.$emit('go-register')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }